import React from 'react'
import Reflux from 'reflux'
import _ from 'lodash'
import FontAwesome from 'react-fontawesome'
// import { Container, Row, Col } from 'reactstrap'
// import { Container, Row, Col, Button, Card, CardBody, CardHeader } from 'reactstrap'

import ListStore from '~/modules/shoppingList/listStore.js'
import ListActions from '~/modules/shoppingList/listActions.js'

// import CoreSimpleTextbox from 'core/simpleTextbox.jsx'


export default class ShoppingListOutput extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = ListStore
		this.storeKeys = [
			'shoppingList'
		]
	}

	render() {
		const totalIngredientsList = []

		_.forEach(
			this.state.shoppingList,
			list => _.forEach(
				list.ingredients,
				x => totalIngredientsList.push({
					recipeIngredientID: x.recipeIngredientID,
					ingredientID: x.ingredientID,
					amount: x.amount,
					quantity: x.quantityName,
					ingredient: x.ingredientName,
					purchased: x.purchased
				})
			)
		)

		const distinctIngredientsCount = _.uniq(
			_.map(totalIngredientsList, 'ingredientID')
		).length

		// console.log('totalIngredientsList >> ', totalIngredientsList);
		// console.log('unique ingredients >> ', distinctIngredientsCount);
		// console.log('array length >> ', totalIngredientsList.length);
		// console.log('SANITY  >> ', distinctIngredientsCount === totalIngredientsList.length ? 'EQUALS' : 'DIFFERENCE');

		const mappedQuantities = _.sortBy(totalIngredientsList, 'ingredient').map(
			x => (
				<tr key={x.recipeIngredientID}>
					<td>
						{
							(x.purchased !== 1)
								? <button style={{ width: '5.2em', color: '#990' }} onClick={() => ListActions.setPurchased(x.ingredientID)}>
									<FontAwesome fixedWidth name="exclamation" />
									Need
									{' '}
									</button>
								: <button style={{ width: '5.2em', color: '#090', backgroundColor: 'transparent', border: '1px solid transparent' }} onClick={() => ListActions.setPurchased(x.ingredientID)}>
									<FontAwesome fixedWidth name="check" />
									{' '}
									Have
									</button>
						}
					</td>
					<td style={{ textAlign: 'right' }}>
						{x.amount}
						{' '}
						{x.quantity}
					</td>
					<td>
						{' '}
					</td>
					<td>
						{x.ingredient}
					</td>
				</tr>
			)
		)

		return (
			<React.Fragment>
				<p>
					<strong>
						You have {distinctIngredientsCount} ingredients you need to purchase
					</strong>
				</p>

				<table>
					<thead>
						<tr>
							<th colSpan={2}>Amount</th>
							<th>Ingredient</th>
						</tr>
					</thead>
					<tbody>
						{mappedQuantities}
					</tbody>
				</table>
			</React.Fragment>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/shoppingList/list.jsx